import { Heading, Subheading, Paragraph } from 'components/src/typography';
import Button from 'components/src/button';
import { PackageSuggestionFormFieldFragment } from 'types/generated';
import { ImageWithFocalPoint } from '../ImageWithFocalPoint';
import typewriter from '@/analytics/segment';
import { getOr } from '@/utils/options';
import SlideIn from '../Transitions/SlideIn';

type Props = {
  data: PackageSuggestionFormFieldFragment;
  onStartClick: () => void;
};

const InitialSection = ({ data, onStartClick }: Props) => {
  return (
    <>
      <div className="col-span-6 col-start-2 self-center md:col-span-4 md:col-start-3">
        <SlideIn direction="right">
          {data.subheading && (
            <Subheading classes="mb-8 text-white-100" small>
              {data.subheading}
            </Subheading>
          )}
          {data.title && (
            <Heading variant="small" classes="text-white-100">
              {data.title}
            </Heading>
          )}
          {data.description && <Paragraph classes="mt-16 text-white-100">{data.description}</Paragraph>}
        </SlideIn>
        <Button
          label={'Byrja'}
          variant={'tertiary'}
          classes="mt-56 w-full md:w-auto"
          onClick={() => {
            // The user has viewed the first (next) step of the package suggestion form by clicking the "Byrja" button
            typewriter.packageSuggestionStepViewed({
              step: 1,
              stepTitle: getOr(data.inputFormsCollection?.items?.[0]?.title, 'Enginn titill fyrir skref'),
            });
            onStartClick();
          }}
        />
      </div>
      <div className="relative col-span-full col-start-8 hidden bg-black-25 md:grid">
        {data.image && (
          <ImageWithFocalPoint image={data.image} sectionId={data.image?.id} sizes={{ breakpoints: { md: '50vw' } }} />
        )}
      </div>
    </>
  );
};
export default InitialSection;
